import groq from 'groq'
import { imageAsset } from '../../../projections/imageAsset'
import { mediaAsset } from '../../../projections/mediaAsset'

export const introduction = groq`
  _type,
  title,
  features[]{
    ...
  },
  "image": coalesce(
    image{...${imageAsset()}},
    featuredMediaAsset[_type == 'imageAsset'][0]{...${mediaAsset()}},
    mediaAsset[_type == 'imageAsset'][0]{...${mediaAsset()}},
    media[_type == 'imageAsset'][0]{...${mediaAsset()}},
    featuredMediaAsset.image{...${imageAsset()}},
    mediaAsset.image{...${imageAsset()}},
    media.image{...${imageAsset()}}
  ),
  "imageMobile": coalesce(
    imageMobile{...${imageAsset()}},
    featuredMediaAsset[_type == 'imageAsset'][1]{...${mediaAsset()}},
    mediaAsset[_type == 'imageAsset'][1]{...${mediaAsset()}},
    media[_type == 'imageAsset'][1]{...${mediaAsset()}},
    featuredMediaAsset.imageMobile{...${imageAsset()}},
    mediaAsset.imageMobile{...${imageAsset()}},
    media.imageMobile{...${imageAsset()}},
    featuredMediaAsset[_type == 'imageAsset'][0]{...${mediaAsset()}},
    mediaAsset[_type == 'imageAsset'][0]{...${mediaAsset()}},
    media[_type == 'imageAsset'][0]{...${mediaAsset()}},
    image{...${imageAsset()}}
  )
`
